import { TextFilterType } from '../../../../../types';
import { TeamNewFinStatusReasonTagID } from '../../../../../main/teams/teamsTypes';

export type UniversalFilterCompanyNewFinTagID = TeamNewFinStatusReasonTagID;

export const enum UniversalFilterCompanyNewFinTagsModes {
  IS_ANY_OF = 'is_any_of',
  IS_NONE_OF = 'is_none_of'
}

export type UniversalFilterCompanyNewFinTagsValue = TextFilterType;

export type UniversalFilterCompanyNewFinTagsFilterState = {
  mode: UniversalFilterCompanyNewFinTagsModes;
  tagIds?: UniversalFilterCompanyNewFinTagID[];
};

export type UniversalFilterCompanyNewFinTagsOnFilterStateChange = (
  state: UniversalFilterCompanyNewFinTagsFilterState
) => void;

export type UniversalFilterCompanyNewFinTagsOnChange = (
  value?: UniversalFilterCompanyNewFinTagsValue
) => void;
